import { appRoutes, PERSIST_STORE_KEY, useAppSelector, useLogoutLogic } from 'azshared';
import React, { Fragment, useEffect, useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useGlobalActions } from 'src/hooks/global-actions';

export const PrivateRoute = () => {
  const globalActions = useGlobalActions();
  const { onLogout } = useLogoutLogic(globalActions);
  const storedToken: string = useAppSelector((state) => state.data?.user?.token);

  const token = useMemo(() => {
    if (storedToken) {
      return storedToken;
    }

    const user = sessionStorage.getItem(PERSIST_STORE_KEY);
    if (user) {
      return JSON.parse(user)?.token;
    }

    return undefined;
  }, [storedToken]);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(onLogout, 5 * 60 * 1000);
    };
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('mousedown', resetTimer);
    window.addEventListener('click', resetTimer);
    window.addEventListener('scroll', resetTimer);
    window.addEventListener('touchstart', resetTimer);
    window.addEventListener('keydown', resetTimer);

    resetTimer();

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('mousedown', resetTimer);
      window.removeEventListener('click', resetTimer);
      window.removeEventListener('scroll', resetTimer);
      window.removeEventListener('touchstart', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [onLogout]);

  return <Fragment>{!token ? <Navigate to={appRoutes.Login} replace /> : <Outlet />}</Fragment>;
};
